import { render, staticRenderFns } from "./GameConfigWx.vue?vue&type=template&id=106dd894&scoped=true&"
import script from "./GameConfigWx.vue?vue&type=script&lang=js&"
export * from "./GameConfigWx.vue?vue&type=script&lang=js&"
import style0 from "./GameConfigWx.vue?vue&type=style&index=0&lang=css&"
import style1 from "./GameConfigWx.vue?vue&type=style&index=1&lang=css&"
import style2 from "./GameConfigWx.vue?vue&type=style&index=2&id=106dd894&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106dd894",
  null
  
)

export default component.exports